import React from 'react';
import './DividerLine.scss';

const DividerLine = () => {
  return <div className='divider-line-brk'></div>;
};

export default DividerLine;
